import { render, staticRenderFns } from "./StaffBundle.vue?vue&type=template&id=0160ccaa&"
import script from "./StaffBundle.vue?vue&type=script&lang=js&"
export * from "./StaffBundle.vue?vue&type=script&lang=js&"
import style0 from "./StaffBundle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports